export default "__VITE_ASSET__vznQpE5T__"